import React from 'react';
import './InfoPage.css';

function Investors() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Relações com Investidores</h1>

        <section className="info-section">
          <h2>Construindo o futuro das viagens e da hospitalidade</h2>
          <p>Bem-vindo à página de Relações com Investidores da Nukki. Aqui você encontrará informações financeiras, relatórios e atualizações para nossa comunidade de investidores.</p>
        </section>

        <section className="info-section">
          <h3>Visão Geral da Empresa</h3>
          <p>A Nukki é um mercado online líder para estadias de curto prazo e experiências. Nossa plataforma conecta milhões de anfitriões e viajantes em todo o mundo, possibilitando experiências de viagem únicas e oportunidades econômicas para pessoas comuns.</p>

          <div className="stats-grid">
            <div className="stat-box">
              <span className="stat-number">10M+</span>
              <span className="stat-label">Anúncios Ativos</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">190+</span>
              <span className="stat-label">Países e Regiões</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">500M+</span>
              <span className="stat-label">Chegadas de Hóspedes</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">R$ 50B+</span>
              <span className="stat-label">Ganhos de Anfitriões (2024)</span>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Destaques Financeiros T3 2024</h3>

          <div className="feature-box">
            <h4>Forte Crescimento de Receita</h4>
            <ul>
              <li>Receita do T3: R$ 16 bilhões (aumento de 18% ano a ano)</li>
              <li>Noites e Experiências Reservadas: 113,2 milhões (aumento de 14% ano a ano)</li>
              <li>Valor Bruto de Reservas: R$ 91,5 bilhões (aumento de 16% ano a ano)</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Lucratividade e Fluxo de Caixa</h4>
            <ul>
              <li>Lucro Líquido: R$ 6 bilhões</li>
              <li>EBITDA Ajustado: R$ 9 bilhões (margem: 35%)</li>
              <li>Fluxo de Caixa Livre: R$ 7,5 bilhões</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Métricas da Plataforma</h4>
            <ul>
              <li>Anúncios Ativos: 7,5 milhões (aumento de 12% ano a ano)</li>
              <li>Reservadores Ativos: 125 milhões</li>
              <li>Taxa Diária Média: R$ 810 (aumento de 8% ano a ano)</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Destaques de Investimento</h3>

          <div className="feature-grid">
            <div className="feature-box">
              <h4>🌍 Líder de Mercado Global</h4>
              <p>Posição dominante no mercado de aluguel de curto prazo com presença em mais de 190 países e expansão internacional contínua.</p>
            </div>
            <div className="feature-box">
              <h4>📈 Crescimento Sustentável</h4>
              <p>Crescimento consistente de receita de dois dígitos impulsionado pelo aumento da demanda de viagens e melhorias na plataforma.</p>
            </div>
            <div className="feature-box">
              <h4>💪 Forte Lucratividade</h4>
              <p>Modelo de negócios de alta margem com economia unitária em melhoria e forte geração de fluxo de caixa livre.</p>
            </div>
            <div className="feature-box">
              <h4>🔄 Efeitos de Rede</h4>
              <p>Mais anfitriões atraem mais hóspedes, criando um ciclo virtuoso que fortalece nossa posição competitiva.</p>
            </div>
            <div className="feature-box">
              <h4>💡 Inovação de Produtos</h4>
              <p>Investimento contínuo em tecnologia e novos produtos para aprimorar a experiência do usuário e expandir nosso mercado.</p>
            </div>
            <div className="feature-box">
              <h4>🎯 Alocação de Capital</h4>
              <p>Abordagem disciplinada para alocação de capital, equilibrando investimentos de crescimento com retornos aos acionistas.</p>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Relatórios Financeiros</h3>

          <div className="help-topic">
            <h4>Resultados Trimestrais</h4>
            <ul>
              <li>Relatório de Lucros T3 2024 (PDF)</li>
              <li>Carta aos Acionistas T3 2024 (PDF)</li>
              <li>Apresentação de Lucros T3 2024 (PDF)</li>
              <li>Transcrição da Chamada de Lucros T3 2024</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Relatórios Anuais</h4>
            <ul>
              <li>Relatório Anual 2023 (10-K)</li>
              <li>Declaração de Procuração 2023</li>
              <li>Carta Anual aos Acionistas 2023</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Arquivamentos na SEC</h4>
            <ul>
              <li>Formulário 10-K (Relatório Anual)</li>
              <li>Formulário 10-Q (Relatório Trimestral)</li>
              <li>Formulário 8-K (Relatório Atual)</li>
              <li>Declarações de Procuração</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Chamadas de Lucros e Eventos</h3>

          <div className="job-listing">
            <h4>Chamada de Lucros T4 2024</h4>
            <div className="job-meta">13 de Fevereiro de 2025 • 14:00 PT</div>
            <p>Junte-se a nós para nossa teleconferência de lucros do T4 2024. Detalhes de webcast e discagem estarão disponíveis.</p>
          </div>

          <div className="job-listing">
            <h4>Dia do Investidor 2025</h4>
            <div className="job-meta">15 de Março de 2025 • São Francisco, CA</div>
            <p>Dia anual do investidor com apresentações de nossa equipe executiva sobre estratégia, produtos e perspectivas financeiras.</p>
          </div>

          <div className="job-listing">
            <h4>Apresentações em Conferências do Setor</h4>
            <div className="job-meta">Datas Variadas • 2025</div>
            <p>A administração da Nukki apresentará em várias conferências de investidores ao longo do ano.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Governança Corporativa</h3>

          <div className="feature-box">
            <h4>Conselho de Administração</h4>
            <p>Nosso conselho traz experiência diversificada em tecnologia, hospitalidade, finanças e negócios globais.</p>
            <ul>
              <li>Composição do Conselho e Comitês</li>
              <li>Biografias dos Diretores</li>
              <li>Cronograma de Reuniões do Conselho</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Documentos de Governança</h4>
            <ul>
              <li>Certificado de Incorporação</li>
              <li>Estatutos</li>
              <li>Regimentos dos Comitês do Conselho</li>
              <li>Código de Conduta Comercial e Ética</li>
              <li>Diretrizes de Governança Corporativa</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>ESG e Sustentabilidade</h4>
            <p>Nosso compromisso com excelência ambiental, social e de governança:</p>
            <ul>
              <li>Relatório de Sustentabilidade</li>
              <li>Iniciativas de Diversidade e Inclusão</li>
              <li>Programas de Impacto Comunitário</li>
              <li>Metas de Redução de Pegada de Carbono</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Informações sobre Ações</h3>

          <div className="feature-box">
            <h4>Informações de Negociação</h4>
            <p><strong>Bolsa:</strong> NASDAQ</p>
            <p><strong>Símbolo:</strong> NUKI</p>
            <p><strong>CUSIP:</strong> 123456789</p>
          </div>

          <div className="feature-box">
            <h4>Preço e Desempenho das Ações</h4>
            <p>Cotações de ações em tempo real, preços históricos e gráficos de desempenho disponíveis através dos principais sites financeiros.</p>
          </div>

          <div className="feature-box">
            <h4>Cobertura de Analistas</h4>
            <p>A Nukki é coberta pelos principais analistas de pesquisa de ações. Não endossamos ou confirmamos quaisquer estimativas ou classificações de analistas.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Contato de Relações com Investidores</h3>

          <div className="feature-box">
            <h4>Consultas de Investidores</h4>
            <p><strong>E-mail:</strong> ir@nukki.com</p>
            <p><strong>Telefone:</strong> +1 (555) 987-6543</p>
            <p><strong>Endereço:</strong> Relações com Investidores Nukki<br/>
            123 Market Street<br/>
            San Francisco, CA 94103</p>
          </div>

          <div className="feature-box">
            <h4>Alertas por E-mail</h4>
            <p>Inscreva-se para receber notificações por e-mail de:</p>
            <ul>
              <li>Comunicados de lucros trimestrais</li>
              <li>Arquivamentos na SEC</li>
              <li>Comunicados de imprensa</li>
              <li>Notificações de eventos</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Aviso Legal</h3>
          <p className="legal-section">Este site e as informações aqui contidas não se destinam a ser uma fonte de aconselhamento de investimento com relação às ações da Nukki ou qualquer outro título. Investidores e investidores em potencial devem conduzir sua própria investigação e análise independente da Nukki e das informações contidas neste site.</p>
        </section>
      </div>
    </div>
  );
}

export default Investors;
